import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '@/core/services/state.service';
import { AbschnittDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model';
import { Subscription } from 'rxjs';
import { ValidationFailure } from '@/api/models/FluentValidation/Results/validation-failure';
import { SectionService } from '@/core/services/section.service';
import { PortalkonfigurationDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { I18nService } from '@/core/services/i18nService';
import { PortalContextService } from '@/core/services/portal-context.service';
import { AnfrageService } from '@/api/service-index';

@Component({
  selector: 'validation-summary',
  templateUrl: './validation-summary.component.html',
  styleUrls: ['./validation-summary.component.scss']
})
export class ValidationSummaryComponent implements OnInit, OnDestroy {

  protected _portalkonfiguration: PortalkonfigurationDisplayModel;
  protected subscription: Subscription;
  protected validationMessages: string[] = [];
  public get ValidationMessages(): string[] {
    return this.validationMessages;
  }
  protected _currentAbschnitt: AbschnittDisplayModel | null;

  @Input() public languageChangeCallbackFunction = (): void => this.languageChangeAnfrageCallbackFunction()

  public get IsVisible()
  {
    return this.stateService.showAnfrageInfo && this.ValidationMessages.length > 0 && this._portalkonfiguration.validierungsubersichtInSidebarAnzeigen === true;
  }

  constructor(protected stateService: StateService, protected router: Router, protected sectionService: SectionService, protected route: ActivatedRoute, protected languageService: I18nService, protected portalContextService: PortalContextService, protected anfrageService: AnfrageService) {
    this._portalkonfiguration = this.route.snapshot.parent?.data.portalkonfiguration;

    this.subscription = languageService.languageChangedBackend$.subscribe(() => {
      this.languageChangeCallbackFunction();
    })
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onValidationErrorsChanged(valErrorList: { [key: string]: ValidationFailure[]; } | null) {

    if (valErrorList && this._currentAbschnitt?.id) {
      let errors: ValidationFailure[] = valErrorList[this._currentAbschnitt?.id];
      this.generateErrorMessages(errors);
    }
  }

  ngOnInit() {
    this.router.events.subscribe(this.updateValMessages.bind(this));
    this.stateService.onValidationErrorsChanged$.subscribe(this.updateValMessages.bind(this));
  }

  updateValMessages() {
    this._currentAbschnitt = this.sectionService.current();

    if (this._currentAbschnitt?.id && this.stateService.ValidationErrors) {
      let errors: ValidationFailure[] = this.stateService.ValidationErrors[this._currentAbschnitt?.id];

      this.generateErrorMessages(errors);
    } else {
      this.generateErrorMessages([]);
    }
  }

  generateErrorMessages(errors: ValidationFailure[]) {
    this.validationMessages = [];
    errors?.forEach((validationError, i) => {
      if (validationError?.errorMessage)
        this.validationMessages.push(validationError.errorMessage);
    });
  }

  languageChangeAnfrageCallbackFunction(){
    const id: string = this.portalContextService.CurrentAnfrage?.id;

        if (id && this._currentAbschnitt?.name) {
            this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: id, reportId: this.portalContextService.CurrentBericht?.projektberichtId, gutachtenId: this.portalContextService.CurrentGutachten?.gutachtenId ?? undefined }).subscribe(result => {
              this.stateService.ValidationErrors = result;
            })
        }
  }
}